import React, { useEffect, useState } from "react";
import { useParams, Link, useHistory } from "react-router-dom";
import TextInput from "component/common/TextInput/index";
import TextField from "component/common/TextField/index";
import RadioButton from "component/common/RadioButton/index";
import ImageSlider from "component/common/ImageSlider/index";
import { getDonationById } from "service/Donation";
import { getStatusColor } from "utils/helper";
import ProductMedia from "component/common/ProductMedia";
import { Toast } from "utils/toast";
import Moment from "react-moment";
import arrow from "assets/images/arrow.svg";

import styles from "./DonationDetail.module.scss";

const DonationDetail = () => {
  const { id } = useParams();

  const history = useHistory();

  let [donation, setDonation] = useState(null);

  const warrantyRadio = [
    {
      label: "Yes",
      name: "warranty",
      value: 1,
    },
    {
      label: "No",
      name: "warranty",
      value: 0,
    },
  ];

  let [media, setMedia] = useState(false);

  useEffect(() => {
    getDonation();
  }, []);

  const getDonation = async () => {
    try {
      let response = await getDonationById(id);
      if (response.status == 200) {
        setDonation(response.data.data[0]);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  const toggleMedia = () => {
    setMedia(!media);
  };
 
  const handleRefresh = () => {
    getDonation();
  }

  if (donation == null) return null;

  return (
    <>
      <div className={styles.donation_detail}>
        <div className={styles.title}>
          <img
            src={arrow}
            className="back-arrow"
            onClick={() => history.goBack()}
          />
          <b>VIEW DONATION</b>
        </div>
        <div className={styles.donation_status}>
          <label>
            Item Code :
            <span className={styles.item_code} style={{ marginLeft: "10px" }}>
              {donation.itemNo}
            </span>
          </label>
          <label>
            Status :
            <span
              className={getStatusColor(donation.productStatus, true)}
              style={{ marginLeft: "10px" }}
            >
              {donation.productStatus}
            </span>
          </label>
          <div className={styles.donation_edit}>
            <Link to={`/admin/donation/edit/${id}`}>
              <button>EDIT</button>
            </Link>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-2">
          <ImageSlider
            url={donation.imageUrl}
            next="image-next"
            prev="image-prev"
            toggle={toggleMedia}
          />
        </div>
        <div className="col-md-10">
          <div className="row">
            <div className="col-md-3 mb-4">
              <TextInput
                label="Product Title"
                value={donation.productTitle}
                disabled={true}
                color="#000000"
              />
            </div>
            <div className="col-md-3  mb-4">
              <TextInput
                label="Category"
                value={donation.categoryInfo.categoryName}
                disabled={true}
                color="#000000"
              />
            </div>
            <div className="col-md-3 mb-4">
              <TextInput
                label="Brand"
                value={donation.brand}
                disabled={true}
                color="#000000"
              />
            </div>
            <div className="col-md-3  mb-4">
              <TextInput
                label="Size / Category"
                value={donation.size}
                disabled={true}
                color="#000000"
              />
            </div>
            <div className="col-md-3  mb-4">
              <TextInput
                label="Product Condition"
                value={donation.productConditon}
                disabled={true}
                color="#000000"
              />
            </div>
            <div className="col-md-3  mb-4">
              <TextInput
                label="Gender"
                value={donation.gender}
                disabled={true}
                color="#000000"
              />
            </div>
            <div className="col-md-3  mb-4">
              <TextInput
                label="Approximate Wieght"
                value={`${donation.approxWeight} ${donation.productWeightMetrics}`}
                disabled={true}
                color="#000000"
              />
            </div>
            <div className="col-md-3  mb-4">
              <TextInput
                label="Original Date of Purchase"
                type="date"
                value={new Date(
                  donation.originalDateofPurchase
                ).toLocaleDateString()}
                disabled={true}
                color="#000000"
              />
            </div>
            <div className="col-md-3  mb-4">
              <TextInput
                label="Date of Product Resale"
                type="text"
                value={
                  donation?.statusDate?.acceptedOnSale
                    ? donation?.statusDate?.acceptedOnSale
                    : "None"
                }
                color="#000000"
                disabled={true}
              />
            </div>
            <div className="col-md-3  mb-4">
              <TextInput
                label="Product Age"
                value={
                  <Moment fromNow ago>
                    {donation.originalDateofPurchase}
                  </Moment>
                }
                disabled={true}
                color="#000000"
              />
            </div>
            <div className="col-md-3  mb-4">
              <TextInput
                label="Original Price"
                value={Number(donation.originalPrice).toLocaleString("en-In", {
                  maximumFractionDigits: 2,
                  style: "currency",
                  currency: "INR",
                })}
                disabled={true}
                color="#000000"
              />
            </div>
            <div className="col-md-3  mb-4">
              <TextInput
                label="Listing Price"
                value={Number(donation.salePrice).toLocaleString("en-In", {
                  maximumFractionDigits: 2,
                  style: "currency",
                  currency: "INR",
                })}
                disabled={true}
                color="#000000"
              />
            </div>
            <div className="col-md-3  mb-4">
              <TextInput
                label="Delivery Charge"
                value={Number(donation.deliveryCharges).toLocaleString(
                  "en-In",
                  {
                    maximumFractionDigits: 2,
                    style: "currency",
                    currency: "INR",
                  }
                )}
                disabled={true}
                color="#000000"
              />
            </div>
            <div className="col-md-3 mb-4">
              <label
                style={{
                  color: "#979797",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                Warranty Available
              </label>
              <div className={styles.radio_btn}>
                {warrantyRadio.map((list, index) => {
                  return (
                    <RadioButton
                      key={index}
                      label={list.label}
                      isChecked={
                        donation.warranty === list.value ? true : false
                      }
                      disabled={true}
                    />
                  );
                })}
              </div>
            </div>
            {donation.warranty === 1 && (
              <div className="col-md-3 mb-4">
                <TextField
                  label="Warranty Period"
                  value={donation.warrantyPeriod}
                  disabled={true}
                  color="#000000"
                />
              </div>
            )}
            <div className="col-md-12 mb-4">
              <TextField
                label="Product Description"
                value={donation.productDescription}
                disabled={true}
                color="#000000"
              />
            </div>
            <div className="col-md-12 mb-4">
              <TextInput
                label="Product Damages (if any)"
                value={
                  donation.productDamage == "" ? "Nil" : donation.productDamage
                }
                disabled={true}
                color="#000000"
              />
            </div>
            <div className="col-md-12 mb-4">
              <TextField
                label="Notes"
                value={donation.notes}
                disabled={true}
                color="#000000"
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.donation_seller}>
        <b>SELLER DETAILS</b>
      </div>
      <div className="row">
        <div className="col-md-3  mb-4">
          <TextInput
            label="Seller Name"
            value="Deepa Jain"
            disabled={true}
            color="#000000"
          />
        </div>
        <div className="col-md-3  mb-4">
          <TextInput
            label="Seller Email ID"
            value="deepa.jain@gmail.com"
            disabled={true}
            color="#000000"
          />
        </div>
        <div className="col-md-3  mb-4">
          <TextInput
            label="Seller Phone Number"
            value="+91 9719763290"
            disabled={true}
            color="#000000"
          />
        </div>
        <div className="col-md-3 mb-4">
          <TextField
            label="Seller Address"
            value="2112, Sobha Malachite,  Jakkur Main Road, Yelahanka, Bengaluru , Karnataka, 560064"
            disabled={true}
            color="#000000"
          />
        </div>
      </div>
      <div className={styles.donation_seller}>
        <b>BUYER DETAILS</b>
      </div>
      <div className="row">
        <div className="col-md-3  mb-4">
          <TextInput
            label="Buyer Name"
            value="Deepa Jain"
            disabled={true}
            color="#000000"
          />
        </div>
        <div className="col-md-3  mb-4">
          <TextInput
            label="Buyer Instagram Handle"
            value="deepa.jain@gmail.com"
            disabled={true}
            color="#000000"
          />
        </div>
        <div className="col-md-3  mb-4">
          <TextInput
            label="Buyer Phone Number"
            value="+91 9719763290"
            disabled={true}
            color="#000000"
          />
        </div>
        <div className="col-md-3 mb-4">
          <TextField
            label="Buyer Address"
            value="2112, Sobha Malachite,  Jakkur Main Road, Yelahanka, Bengaluru , Karnataka, 560064"
            disabled={true}
            color="#000000"
          />
        </div>
        <div className="col-md-3  mb-4">
          <TextInput
            label="Payment Method"
            value="VISA *************5671"
            disabled={true}
            color="#000000"
          />
        </div>
        <div className="col-md-3  mb-4">
          <TextInput
            label="Date of Purchase"
            type="date"
            value="2021-06-11"
            disabled={true}
            color="#000000"
          />
        </div>
      </div>
      <div className={styles.donation_seller}>
        <b>TRANSACTION DETAILS</b>
      </div>
      <div className="row">
        <div className="col-md-3  mb-4">
          <TextInput
            label="Amount Received From Buyer"
            value="₹ 350"
            disabled={true}
            color="#000000"
          />
        </div>
        <div className="col-md-3  mb-4">
          <TextInput
            label="Profit %"
            value="100"
            disabled={true}
            color="#000000"
          />
        </div>
        <div className="col-md-3  mb-4">
          <TextInput
            label="Courier Sip Date"
            type="date"
            value="2021-06-11"
            disabled={true}
            color="#000000"
          />
        </div>
        <div className="col-md-3 mb-4">
          <TextInput
            label="Courier Partner"
            value="BlueDart"
            disabled={true}
            color="#000000"
          />
        </div>
        <div className="col-md-3  mb-4">
          <TextInput
            label="Shipping Charge"
            value="₹ 180"
            disabled={true}
            color="#000000"
          />
        </div>
      </div>
      <ProductMedia
        url={donation.imageUrl}
        data={donation}
        isOpen={media}
        toggle={toggleMedia}
        showAction={false}
        handleRefresh={handleRefresh}
      />
    </>
  );
};

export default DonationDetail;
